module.exports = __webpack_public_path__ + "static/media/_denmark.be60e04c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_denmark.svg
// module id = 2316
// module chunks = 7